import { Order } from '@/types'
import { 
  ShoppingCartIcon, 
  CurrencyDollarIcon, 
  CubeIcon,
  ClockIcon
} from '@heroicons/react/24/outline'

interface DashboardSummaryProps {
  orders: Order[]
}

export function DashboardSummary({ orders }: DashboardSummaryProps) {
  const stats = {
    totalOrders: orders.length,
    totalVolume: orders.reduce((sum, order) => sum + order.totalAmount, 0),
    totalProducts: orders.reduce((sum, order) => 
      sum + order.products.reduce((productSum, product) => productSum + product.quantity, 0), 0),
    ordersInProgress: orders.filter(o => 
      ['pending_confirmation', 'confirmed', 'in_production', 'final_testing', 'ready_for_shipping', 'in_delivery'].includes(o.status)
    ).length,
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
        <div className="flex items-center">
          <div className="p-3 rounded-full bg-blue-100 dark:bg-blue-900">
            <ShoppingCartIcon className="h-6 w-6 text-blue-600 dark:text-blue-400" />
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-medium dark:text-white">Total Orders</h3>
            <p className="text-2xl font-bold text-blue-600 dark:text-blue-400">
              {stats.totalOrders}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
        <div className="flex items-center">
          <div className="p-3 rounded-full bg-green-100 dark:bg-green-900">
            <CurrencyDollarIcon className="h-6 w-6 text-green-600 dark:text-green-400" />
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-medium dark:text-white">Total Volume</h3>
            <p className="text-2xl font-bold text-green-600 dark:text-green-400">
              ${stats.totalVolume.toLocaleString()}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
        <div className="flex items-center">
          <div className="p-3 rounded-full bg-purple-100 dark:bg-purple-900">
            <CubeIcon className="h-6 w-6 text-purple-600 dark:text-purple-400" />
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-medium dark:text-white">Products Purchased</h3>
            <p className="text-2xl font-bold text-purple-600 dark:text-purple-400">
              {stats.totalProducts.toLocaleString()}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
        <div className="flex items-center">
          <div className="p-3 rounded-full bg-yellow-100 dark:bg-yellow-900">
            <ClockIcon className="h-6 w-6 text-yellow-600 dark:text-yellow-400" />
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-medium dark:text-white">Orders in Progress</h3>
            <p className="text-2xl font-bold text-yellow-600 dark:text-yellow-400">
              {stats.ordersInProgress}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
} 